import { AutomatedNotification, NotificationCategory } from 'types/notifications';
import { portalAPI } from './portalAPI';
import { filteredAndSortedQuery } from './util/filteredAndSortedQuery';

export const APINotificationsSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['Notifications'] }).injectEndpoints({
    endpoints: (builder) => ({
        getNotificationsList: filteredAndSortedQuery<AutomatedNotification>(builder, '/v1/notifications', {
            providesTags: ['Notifications'],
        }),
        readNotification: builder.mutation<AutomatedNotification, { id: string | number; skipButtonDisable?: boolean }>(
            {
                query: ({ id, skipButtonDisable }) => ({
                    url: `/v1/notifications/read/${id}`,
                    method: 'PUT',
                    _skipButtonDisable: skipButtonDisable,
                }),
                invalidatesTags: (_1, _2, arg) =>
                    arg.id ? ['Notifications', { type: 'Notifications', id: arg.id }] : ['Notifications'],
            }
        ),
        readNotifications: builder.mutation<
            AutomatedNotification[],
            { type: NotificationCategory; skipButtonDisable?: boolean }
        >({
            query: ({ type, skipButtonDisable }) => ({
                url: `/v1/notifications/read/all/${type}`,
                method: 'PUT',
                _skipButtonDisable: skipButtonDisable,
            }),
            invalidatesTags: ['Notifications'],
        }),
        archiveNotification: builder.mutation<AutomatedNotification, { id: string | number }>({
            query: ({ id }) => ({
                url: `/v1/notifications/archive/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ['Notifications'],
        }),
        archiveNotifications: builder.mutation<AutomatedNotification[], { type: NotificationCategory }>({
            query: ({ type }) => ({
                url: `/v1/notifications/archive/all/${type}`,
                method: 'PUT',
            }),
            invalidatesTags: ['Notifications'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetNotificationsListQuery,
    useReadNotificationMutation,
    useReadNotificationsMutation,
    useArchiveNotificationMutation,
    useArchiveNotificationsMutation,
} = APINotificationsSlice;
